import { NotFound } from "../../components/Pages/NotFound";

export const NotFoundPage = () => {
  return <NotFound />;
};
